import React from 'react'

//Node Modules
import {Nav, Navbar} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

//Components
import Divider from 'components/Divider'

//Styles
import styles from './Footer.module.scss'

//Hooks
import { useIsSmallDevice } from 'hooks'

const Footer = () => {
  const { t } = useTranslation()
  const isSmallDevice = useIsSmallDevice()

  return (
    <div className={styles.footer}>
      <Navbar className={styles.navbar} variant="dark">
        <div className={styles.left}></div>
        <Nav className={styles.right} data-testid="footer-right">
          <Divider variant="dark">
            <Nav.Link 
              href="http://www.sas.com/en_us/legal/privacy.html" 
              rel="noopener noreferrer" 
              className={styles.link}
              data-testid="privacy-link"
            >
              {t('helpcenter-gui-icu.footer.privacy.label')}
            </Nav.Link>
            <Nav.Link 
              href="http://www.sas.com/en_us/legal/copyright.html" 
              rel="noopener noreferrer" 
              className={styles.link}
              data-testid="copyright-link"
            >
              {t('helpcenter-gui-icu.footer.terms.label')}
            </Nav.Link>
            { 
              !isSmallDevice && 
              <Nav.Item 
                className={styles.copyright}
                data-testid="copyright-statement"
              >
                {t('helpcenter-gui-icu.footer.reserved.msg')}
              </Nav.Item> 
            }
          </Divider>
        </Nav>
      </Navbar>
    </div>
  )
}

export default Footer